import React from 'react';
import { useTheme } from '@emotion/react';
/**
 * 인라인 코드 블록 컴포넌트
 * 짧은 코드 스니펫을 텍스트 내에서 표시할 때 사용
 */ var InlineCodeBlock = function(param) {
    var className = param.className, children = param.children;
    var theme = useTheme();
    return /*#__PURE__*/ React.createElement("code", {
        className: className,
        style: {
            backgroundColor: theme.isDark ? theme.paperDark : theme.paperLight,
            color: theme.textSecondary,
            padding: '0.2em 0.4em',
            borderRadius: theme.radius.sm,
            fontSize: '0.9em',
            fontFamily: theme.typography.fontFamily
        }
    }, children);
};
export default InlineCodeBlock;
